import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ReportContext, ReportDefinition } from '../../report.models';
import { RouteActionEvent } from '../route-function-report/route-analysis-report/route-analysis-report.models';
import { RouteAnalysisTableComponent } from '../route-function-report/route-analysis-report/route-analysis-table.component';
import { VehicleFinanceReportApiService } from './vehicle-finance-report-api.service';
import { InvoiceDialog, VehicleFinanceCredentials, VehicleFinanceRow } from './vehicle-finance-report.models';
import { FINANCE_INCOME_COLUMNS, FINANCE_INCOME_EXPORT_COLUMNS, FINANCE_INVOICE_ACTIONS, FINANCE_REPAIR_COLUMNS, FINANCE_REPAIR_EXPORT_COLUMNS, FINANCE_SUMMARY_COLUMNS, financeSummary, invoiceImageMarkup } from './vehicle-finance-report.utils';

declare const $: { confirm(options: InvoiceDialog): void };

@Component({ selector: 'app-vehicle-finance-report', templateUrl: './vehicle-finance-report.component.html' })
export class VehicleFinanceReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: VehicleFinanceRow[] = [];
  loading = false;
  hasError = false;
  private requestVersion = 0;
  constructor(private readonly api: VehicleFinanceReportApiService, private readonly guard: GurdServiceService,
    private readonly notification: NotificationService, private readonly other: OtherService,
    private readonly router: Router, private readonly location: Location) {}
  get isRepairs(): boolean { return this.context.type === '4'; }
  get isIncome(): boolean { return this.context.type === '5'; }
  get columns() { return this.isRepairs ? FINANCE_REPAIR_COLUMNS : this.isIncome ? FINANCE_INCOME_COLUMNS : FINANCE_SUMMARY_COLUMNS; }
  get exportColumns() { return this.isRepairs ? FINANCE_REPAIR_EXPORT_COLUMNS : this.isIncome ? FINANCE_INCOME_EXPORT_COLUMNS : FINANCE_SUMMARY_COLUMNS; }
  get actions() { return this.isRepairs ? FINANCE_INVOICE_ACTIONS : []; }
  get tableKey(): string { return `finance-${this.context.id}-${this.context.type}`; }
  get subtitle(): string { return `از تاریخ ${this.context.startDate} الی ${this.context.endDate}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.requestVersion;
    this.loading = false;
    this.rows = [];
    this.table?.reset();
    void this.loadReport();
  }
  ngOnDestroy(): void { ++this.requestVersion; }
  async loadReport(): Promise<void> {
    if (this.loading) return;
    const requestVersion = ++this.requestVersion;
    this.loading = true;
    this.hasError = false;
    try {
      const result = await this.api.load(this.context, this.credentials());
      if (requestVersion !== this.requestVersion) return;
      if (!('repairs' in result)) {
        this.notification.showError('لطفا وارد سیستم شوید');
        this.other.removeLocalStorage();
        void this.router.navigate(['login']);
        return;
      }
      this.rows = this.isRepairs ? result.repairs : this.isIncome ? result.income : financeSummary(result.repairs, result.income);
    } catch {
      if (requestVersion !== this.requestVersion) return;
      this.rows = [];
      this.hasError = true;
    } finally { if (requestVersion === this.requestVersion) this.loading = false; }
  }
  onRowAction(event: RouteActionEvent): void {
    if (this.loading || !this.isRepairs || event.action !== 'invoice') return;
    const content = invoiceImageMarkup(String(event.row['strImage'] ?? ''));
    if (!content) { this.notification.showInfo('تصویر فاکتور موجود نیست', ''); return; }
    $.confirm({ title: 'فاکتور', content, type: 'blue', buttons: { cancel: { text: 'بستن' } } });
  }
  goBack(): void { this.location.back(); }
  private credentials(): VehicleFinanceCredentials {
    const user = localStorage.getItem('ID')!;
    const session = localStorage.getItem('Session')!;
    // Preserve the legacy income endpoint's encryption of stored credentials.
    return {
      repairUser: this.isIncome ? '' : this.guard.decrypt(user),
      repairSession: this.isIncome ? '' : this.guard.decrypt(session),
      incomeUser: this.isRepairs ? '' : this.guard.encrypt(user),
      incomeSession: this.isRepairs ? '' : this.guard.encrypt(session),
    };
  }
}
